import { Card, cents, when } from './dsfApi';

const KIND = { join: ['Joined', 'text-white/80'], reconnect: ['Reconnected', 'text-amber-300'], dropped: ['Dropped', 'text-red-400'], stall: ['Paused', 'text-orange-300'] };

export const DsfLiveCard = ({ live }) => {
    const players = (live?.rooms || []).flatMap((r) => r.players.map((p) => ({ ...p, room: r.room })));
    const c = live?.last_24h || {};
    return (
        <Card title="Playing now & connection log" testid="dsf-live-card"
            right={<span className="text-xs text-white/50" data-testid="dsf-live-24h">Last 24h: {c.join || 0} joins · {c.reconnect || 0} reconnects · {c.dropped || 0} drops · {c.stall || 0} pauses</span>}>
            {live?.error && <p className="mb-2 text-sm text-amber-300" data-testid="dsf-live-error">{live.error}</p>}
            {(live?.servers?.perf || []).filter((p) => p.msgs).map((p) => (
                <p key={p.node} className="mb-2 text-xs text-white/60" data-testid={`dsf-perf-${p.node}`}>
                    Server {p.node}: {p.msgs} updates (last 10 min) · avg {p.avg_ms} ms · slowest {p.max_ms} ms · game {p.game_max_ms} ms · waiting {p.lock_wait_max_ms} ms · server busy {p.loop_lag_max_ms} ms · {p.slow} slow
                </p>
            ))}
            {!players.length ? <p className="mb-4 text-white/50" data-testid="dsf-live-empty">Nobody at the fish table right now.</p> : (
                <table className="mb-4 w-full text-sm text-[#cfd6dc]">
                    <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#A0AAB2]">
                        <th className="pb-2">Player</th><th className="pb-2">Room</th><th className="pb-2 text-right">Bet</th><th className="pb-2 text-right">Balance</th><th className="pb-2 text-right">Status</th>
                    </tr></thead>
                    <tbody>{players.map((p) => (
                        <tr key={p.userId} className="border-t border-white/5" data-testid={`dsf-live-player-${p.userId}`}>
                            <td className="py-1.5">{p.name || p.email}</td><td>{p.room} · seat {p.seat + 1}</td>
                            <td className="text-right">{cents(p.betLevelCents)}</td><td className="text-right tabular-nums">{cents(p.balanceCents)}</td>
                            <td className="text-right text-xs">{p.firing ? <span className="text-[#39FF14]">firing</span> : `idle ${p.seenSecondsAgo}s`}</td>
                        </tr>
                    ))}</tbody>
                </table>
            )}
            <div className="max-h-[300px] overflow-auto">
                <table className="w-full text-sm text-[#cfd6dc]">
                    <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#A0AAB2]">
                        <th className="pb-2">Time</th><th className="pb-2">Player</th><th className="pb-2">Event</th><th className="pb-2">Detail</th>
                    </tr></thead>
                    <tbody>{(live?.connection_log || []).map((e, i) => (
                        <tr key={`${e.at}-${i}`} className="border-t border-white/5" data-testid="dsf-log-row">
                            <td className="py-1 text-xs text-white/60">{when(e.at)}</td><td>{e.name || e.email}</td>
                            <td className={KIND[e.kind]?.[1]}>{KIND[e.kind]?.[0] || e.kind}</td>
                            <td className="text-xs text-white/50">{e.detail || (e.status === 200 ? 'ok' : e.status)} · {e.served_by}</td>
                        </tr>
                    ))}</tbody>
                </table>
                {live && !live.connection_log.length && <p className="py-3 text-center text-white/50">No connection events in the last 7 days.</p>}
            </div>
        </Card>
    );
};
